<template>
  <div class="white-bg" v-if="act">
    <div id="reg_page_body" class="page-body">
      <nav id="actTitleNavbar" class="navbar navbar-default" style="margin-bottom:0;">
        <div>
          <div id="actTitleHeader" class="navbar-header">
            <div class="navbar-text" id="actTitle"
              style="display: flex; justify-content: center; align-items: center; text-align: center;">
              <button type="button" class="navbar-toggle pull-left expand-tabs-sm" style="margin-left: 8px;"
                data-toggle="collapse" data-target="#navbar-header-collapse" ng-click="resizeElements()">
                <span class="fa fa-bars"></span>
              </button>
              {{ regViewActBean.actView.title }}
            </div>
          </div>
        </div>
      </nav>
      <div class="collapse" style="overflow-x: hidden; padding-left: 0px; padding-right: 0px;"
        id="navbar-header-collapse">
        <div style="margin-top: 15px; margin-bottom: 15px;"></div>
      </div>

      <!-- <timeline v-if="shouldShowTimeline"></timeline> -->
      <div class="row theme-green main-panel">
        <div class="flex-div">
          <div
            class="col-lg-offset-2 col-xl-8 col-lg-10 col-md-offset-0 col-md-12 col-sm-offset-0 col-xs-offset-0 col-sm-12 col-xs-12"
            style="height: 100%; padding: 0;">
            <div id="searchBarPrimary">
              <div class="input-group">
                <span class="input-group- left-search">
                  <button class="btn btn-default" type="button" @click="onPrintClick" title="Штампа">
                    <span class="fa fa-print"></span>
                  </button>
                  <button v-if="!wpp" class="btn btn-default" type="button" @click="onDocxExportClick"
                    title="Експорт у WORD">
                    <span class="fa fa-file-word"></span>
                  </button>
                  <button v-if="!wpp" class="btn btn-default" type="button" @click="onOnlyActContentClick"
                    title="Отвори само текст акта">
                    <span class="fa fa-external-link"></span>
                  </button>
                  <button v-if="implementsShowChanges === true" class="btn btn-default" type="button"
                    @click="toggleShowChanges" title="Прикажи текст са/без посебно назначених измена и допуна">
                    <span class="fa" :class="{
                      'fa-eye': showChanges === false,
                      'fa-eye-slash': showChanges === true,
                    }"></span>
                  </button>
                  <button class="btn btn-default" type="button" @click="onPreviousClick" title="Претходни резултат">
                    <span class="fa fa-chevron-left"></span>
                  </button>
                </span>
                <input @keyup="primaryKeyUp" v-model="textSearch" type="text" class="form-control"
                  placeholder="Претрага по приказаном тексту" />
                <span class="input-group-btn right-search" @click="onNextClick">
                  <button class="last-btn btn btn-default" type="button" title="Следећи резултат">
                    <span class="fa fa-chevron-right"></span>
                  </button>
                </span>
              </div>
            </div>
            <div id="actContentPrimaryScroll" class="view-act-primary card card-1" :class="{
              'full-height':
                act.actAbstract === null || act.actAbstract.length <= 0,
            }" style="overflow-y: auto; position: absolute; top: 35px;">
              <HtmlDiv v-if="hasHtml" id="primaryContentHtml" v-html="contentPrimary" width="100%" height="800px"
                :showChanges="true">
              </HtmlDiv>
              <iframe v-else id="primaryContentHtml" :src="contentPrimary" type="application/pdf" width="100%"
                height="800px" />
            </div>
          </div>

          <div class="col-lg-2 col-md-2 right-panel hidden-xs hidden-sm">
            <div class="panel-group" id="accordion" v-if="act != null">
              <div class="panel panel-default" id="panelAttachments" v-if="act.attachments.length > 0">
                <div data-toggle="collapse" data-target="#collapseAttachments" class="panel-heading">
                  <h5 class="panel-title">
                    <a>
                      Прилози
                    </a>
                  </h5>
                </div>
                <div id="collapseAttachments" class="panel-collapse collapse">
                  <ul class="panel-body list-group" style="padding: 0px!important;">
                    <li class="list-group-item" v-for="link in act.attachments" :key="link.name">
                      <a rel="nofollow" :href="basePPPApiUrl +
                        'ppp/prilozi/' +
                        link.name +
                        '?actId=' +
                        act.id +
                        '&docType=wpp'
                        " v-text="link.name" target="_blank"></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
window.$ = window.jQuery = require("jquery");
import axios from "axios";
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
import "jquery-highlight/jquery.highlight.js";
import HtmlDiv from "@/components/HtmlDiv.vue";
//import { changeImageSrc } from '../../utils/helper-methods';

import { customAxios } from "@/utils/custom-axios";

export default {
  name: "ViewActPage",
  data() {
    return {
      basePPPApiUrl: window.env.VUE_APP_API_PPP_DEV,
      baseSLGLApiUrl: window.env.VUE_APP_API_SLGL_DEV,
      baseREGApiUrl: window.env.VUE_APP_API_REG_DEV,
      baseSPApiUrl: window.env.VUE_APP_API_SP_DEV,
      shouldShowTimeline: this.inAnyRole([
        "NP",
        "PG2010",
        "SGARHSTARO",
        "PGARHSTARO",
        "SLARHSTARO",
        "MUARHSTARO",
        "MUTG",
        "SP",
        "LSD",
        "WPP_ESZLJP_GUIDE",
      ]),
      contentPrimary: null,
      showChanges: false,
      act: null,
      scrollIndex: 0,
      textSearch: "",
      hasHtml: true,
    };
  },
  watch: {
    textSearch(newValue) {
      window
        .$("#actContentPrimaryScroll")
        .unhighlight({ className: "pronadjen" });
      if (newValue !== null && newValue.length > 0) {
        window
          .$("#actContentPrimaryScroll")
          .highlight(newValue, { className: "pronadjen" });
      }
      this.scrollIndex = 0;
    },
    textSearchSecondary(newValue) {
      window.$("#actContentSecondary").unhighlight({ className: "pronadjen" });
      if (newValue !== null && newValue.length > 0) {
        window
          .$("#actContentSecondary")
          .highlight(newValue, { className: "pronadjen" });
      }
      this.scrollIndexSecondary = 0;
    },
    act() {
      var self = this;
      if (self.act) {
        self.hasHtml = self.act.hasHtml;
        customAxios(self.act.hasHtml ? "" : "blob")
          .get(
            self.getViewActUrl(
              self.act.id,
              self.act.actGuid,
              self.act.actType,
              self.act.hasHtml,
              self.act.ogUrl
            )
          )
          .then((response) => {
            if (!self.hasHtml) {
              const file = new Blob([response.data], {
                type: "application/pdf",
              });
              const fileurl = URL.createObjectURL(file);
              self.contentPrimary = fileurl;
            } else {
              self.contentPrimary = response.data;
              //const newContent = changeImageSrc(self.contentPrimary, self.basePPPApiUrl + 'ppp/', self.act.id);
              //self.contentPrimary = newContent;
            }

            self.$nextTick(() => {
              const styleTags = document.getElementById('primaryContentHtml').querySelectorAll('style');
              styleTags.forEach(styleTag => {
                styleTag.innerHTML = '#primaryContentHtml' + styleTag.innerHTML;
                styleTag.innerHTML = styleTag.innerHTML.replace(/}/g, '} #primaryContentHtml');
              });
              window.$("#primaryContentHtml").on("click auxclick", function (e) {
                if (
                  e.target.nodeName === "A" ||
                  e.target.parentElement.nodeName === "A"
                ) {
                  if (e.target.nodeName === "A") {
                    if (e.target.href.includes("/viewdoc"))
                      e.target.href = e.target.href.substr(
                        e.target.href.indexOf("viewdoc")
                      );
                  }
                }
              });
            });
          })
          .catch((error) => {
            console.log(error);
            this.contentPrimary = "Документ не може бити приказан.";
          });
      }
    },
  },
  methods: {
    inAnyRole() {
      return false;
    },
    getViewActUrl(actId, actGuid, base, hasHtml, ogUrl) {
      if (!hasHtml) {
        return this.baseSLGLApiUrl + "Prins/viewDoc?uuid=" + ogUrl;
      } else if (base === "REG") {
        return this.baseREGApiUrl + "viewAct/" + actGuid;
      } else if (base === "SUPA") {
        return this.baseSPApiUrl + "Prins/viewActByGuid/" + actGuid;
      } else if (base === "SLGLRS") {
        return this.baseSLGLApiUrl + "Prins/viewActByGuid/" + actGuid;
      } else if (base === "PP") {
        return this.basePPPApiUrl + "ppp/viewAct/" + actId;
      }
    },
    toggleShowChanges() {
      this.showChanges = !this.showChanges;
      if (this.showChanges === false) {
        window.$("#actContentPrimaryScroll").addClass("state-changes");
      } else {
        window.$("#actContentPrimaryScroll").removeClass("state-changes");
      }
    },
    onPrintClick() {
      if (this.act.actType === 'REG') {
        var base = this.baseREGApiUrl;
        var docType = 'reg';
      }
      else if (this.act.actType === 'SLGLRS') {
        base = this.baseSLGLApiUrl + 'prins/';
        docType = 'og';
      }
      else if (this.act.actType === 'SUPA') {
        base = this.baseSPApiUrl + 'prins/';
        docType = 'sp';
      }
      else {
        base = this.basePPPApiUrl + 'ppp/'
        docType = 'ppp';
      }

      axios.get(base + "viewdoc?uuid=" + this.act.url + "&actId=" + this.act.id.toString() + "&doctype=" + docType)
        .then((response) => {
          var tab = window.open('', '_blank');
          tab.document.write(response.data); // where 'html' is a variable containing your HTML
          tab.document.close();
          setTimeout(() => {
            tab.print();
            tab.close();
          }, 100);
        })
    },
    onNextClick() {
      var items = window.$("#actContentPrimaryScroll").find(".pronadjen");
      if (items && items.length > 0) {
        this.scrollIndex++;
        if (this.scrollIndex > items.length) {
          this.scrollIndex = 0;
        }
        items[this.scrollIndex].scrollIntoView();
      }
    },
    onPreviousClick() {
      var items = window.$("#actContentPrimaryScroll").find(".pronadjen");
      if (items && items.length > 0) {
        this.scrollIndex--;
        if (this.scrollIndex < 0) {
          this.scrollIndex = items.length;
        }
        if (items.length > 0) {
          items[this.scrollIndex].scrollIntoView();
        }
      }
    },
    primaryKeyUp(event) {
      if (event.keyCode === 13) {
        this.onNextClick();
      }
    },
    onDocxExportClick() {
      const lawActId = this.act.id;
      const lawActName = this.regViewActBean.actView.title;

      if (this.act.actType === 'REG')
        var base = this.baseREGApiUrl;

      else if (this.act.actType === 'SLGLRS')
        base = this.baseSLGLApiUrl + 'prins/';

      else if (this.act.actType === 'SUPA')
        base = this.baseSPApiUrl + 'prins/';

      else
        base = this.basePPPApiUrl + 'ppp/'

      axios
        .get(
          base +
          "GeneratePrimaryWordDocument?lawActId=" +
          lawActId,
          { responseType: "blob" }
        )
        .then(function (response) {
          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          link.download = lawActName + ".docx";
          link.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    onOnlyActContentClick() {
      if (this.act.actType === 'REG') {
        var base = this.baseREGApiUrl;
        var docType = 'reg';
      }
      else if (this.act.actType === 'SLGLRS') {
        base = this.baseSLGLApiUrl + 'prins/';
        docType = 'og';
      }
      else if (this.act.actType === 'SUPA') {
        base = this.baseSPApiUrl + 'prins/';
        docType = 'sp';
      }
      else {
        base = this.basePPPApiUrl + 'ppp/'
        docType = 'ppp';
      }
      window.open(base +
        "viewdoc?uuid=" +
        this.act.url +
        "&actId=" +
        this.act.id.toString() +
        "&doctype=" + docType,
        "_blank"
      );
    },
  },
  computed: {
    regViewActBean() {
      return {
        actView: this.act,
        wpp: false,
        eli: true,
        searchQuery: "searchQuery",
      };
    },
    implementsShowChanges() {
      return false;
    },
    wpp() {
      return this.regViewActBean.wpp;
    },
  },
  mounted() {
    axios
      .get(
        this.basePPPApiUrl + "ppp/GetActViewById/" + this.$route.params.actId
      )
      .then((response) => {
        this.act = response.data;
      })
      .catch((error) => {
        if (error.response.status === 403 || error.response.status === 401) window.location.href = '/'
      });
  },
  beforeCreate: function () {
    document.body.className = "color_pp view-act-page";
  },
  components: { HtmlDiv },
};
</script>

<style scoped>
@import "~@fortawesome/fontawesome-free/css/all.css";

.container-slgl {
  padding-left: 15px;
  padding-right: 15px;
  width: 100% !important;
  height: 100% !important;
  overflow: hidden !important;
}

@media (max-width: 1200px) {
  .container-slgl {
    overflow: unset !important;
  }
}

.highlighted {
  background: #ff0;
}

.row {
  margin-right: 0px !important;
  margin-left: 0px !important;
}

.view-act-primary {
  width: 100%;
}

@media (max-width: 990px) {
  #actContentPrimaryScroll {
    margin-bottom: 40px;
  }
}

#actTitleNavbar {
  width: 100% !important;
  display: block !important;
  padding: 0;
}

#actTitleNavbar #actTitle {
  padding: 10px !important;
  font-size: 20px !important;
}

/* section.base-header-sec {
    height: 0 !important;
}

.base-header__top-line.laen {
    display: none !important;
} */

.theme-green.main-panel {
  display: block;
}

@media (min-width: 1200px) {
  .col-lg-offset-2 {
    margin-left: 16.66666667%;
  }
}

#actContentPrimaryScroll {
  height: calc(100vh - 235px) !important;
  top: 41px !important;
  border-top: 2px solid #cccccc;
}

.color_reg .site-header .navbar-pis .nav-link:before,
.color_reg .base-header__top-line {
  background: linear-gradient(103deg, #e14356 0%, white 100%) !important;
}

.top-line__item a:hover {
  text-decoration: none !important;
}

.p-left {
  padding-left: 15px;
}

.theme-green .panel-heading,
#actTitle {
  background: linear-gradient(to bottom, #008fa8 0%, #00798f 100%) !important;
  padding: 10px 15px;
}

.panel.panel-default:not(:first-child) {
  margin: 5px 0 0 0;
}

.panel-title.panel-title {
  margin: 0;
}

.panel-heading {
  border-radius: 4px 4px 0 0;
}

#searchBarPrimary,
.secondary-frame-parent {
  padding: 2px;
}

.left-search .btn-default:hover,
.right-search .btn-default:hover,
#searchBarPrimary .btn-default:hover {
  color: #333; 
  background-color: #e6e6e6 !important; 
  border-color: #adadad !important;
}

#searchBarPrimary .left-search .btn-default,
.secondary-frame-parent .left-search .btn-default {
  background-color: #fff;
  box-shadow: none;
  border-radius: 0;
  border-right: 1px solid #ccc !important;
  border-top: 1px solid #ccc !important;
  border-bottom: 1px solid #ccc !important;
  height: 38px;
}

#searchBarPrimary .left-search,
.secondary-frame-parent .left-search {
  border: none;
}

#searchBarPrimary .left-search .btn-default:first-child,
.secondary-frame-parent .left-search .btn-default:first-child {
  border-radius: 4px 0 0 4px;
  border: 1px solid #ccc !important;
}

#searchBarPrimary .left-search .btn-default:last-child,
.secondary-frame-parent .left-search .btn-default:last-child {
  border-right: none !important;
  background-color: #fff;
}

#searchBarPrimary .right-search,
.secondary-frame-parent .right-search {
  border-left: none !important;
  border-right: none !important;
}

#searchBarPrimary .right-search .btn-default,
.secondary-frame-parent .right-search .btn-default {
  border-left: none !important;
  border-radius: 0 4px 4px 0 !important;
  background-color: #fff;
  height: 36px;
}

.secondary-frame-parent .input-group-btn.previous-solo-btn .btn-default {
  background-color: #fff !important;
  height: 36px !important;
  box-shadow: none !important;
}

.secondary-frame-parent .input-group-btn.previous-solo-btn {
  border-right: none !important;
  border-left: none !important;
}

.secondary-frame-parent .input-group-btn.left-search {
  border-top: none !important;
}

#actContentSecondaryScroll {
  height: 655px !important;
  background-color: #fff;
  border-top: 3px solid #ddd !important;
  padding: 16px;
}

.panel.panel-default ul {
  list-style: none;
}

/* .panel.panel-default ul li {
  font-size: 12px;
} */

.panel.panel-default ul a:hover {
  text-decoration: underline !important;
}

.panel.panel-default h5 {
  /* font-size: 75%; */
  cursor: pointer;
}

.panel.panel-default {
  background-color: #fff !important;
  border-radius: 0 0 4px 4px;
  border: 1px solid #ddd !important;
}

.reference-list ul {
  display: none;
}

.reference-list.expanded ul {
  display: block;
}

.panel-collapse.collapse {
  max-height: 450px;
  overflow: auto;
}

.flex-div {
  display: flex !important;
}

#panelAttachments {
  margin-top: 40px;
}

@media (min-width: 768px) {
  .expand-tabs-sm {
    display: none;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  #navbar-header-collapse {
    display: block;
  }
}

#searchBarPrimary input.form-control::placeholder,
.secondary-frame-parent input.form-control::placeholder {
  color: #a69999 !important;
  font-size: 100% !important;
}

#searchBarPrimary input.form-control,
.secondary-frame-parent input.form-control {
  font-size: 88% !important;
  height: 38px;
}
</style>
